import axios, { ResponseType, auth } from './axios';
import { Employee, Terminal, ActivationCode } from '~/types';
import { terminals } from '~/routes';

export type ApiKey = {
  tokenPrefix: string;
  createdAt: string;
  value?: string;
};

export const getAllTerminals = (): ResponseType<Terminal[]> => {
  return axios.get('/terminals', { params: { page: 1, perPage: 9999 } });
};

export const getTerminals = (params: any): ResponseType<Terminal[]> => {
  return axios.get('/terminals', { params });
};

export const getTerminalById = (id: string) => (): ResponseType<Terminal> => {
  return axios.get(`/${terminals}/${id}`);
};

export const createTerminal = (body: Terminal): ResponseType<Terminal> => {
  return axios.post('/terminals', { ...body, businessId: auth.getProfile() });
};

export const updateTerminal = ({
  id,
  body,
}: {
  id: string;
  body: Terminal;
}): ResponseType<Terminal> => {
  return axios.put(`/${terminals}/${id}`, { ...body, businessId: auth.getProfile() });
};

export const getEmployeesByTerminal = (terminalId: string): ResponseType<Employee[]> => {
  return axios.get(`/terminals/${terminalId}/employees`, { params: { page: 1, perPage: 9999 } });
};

export const issueActivationCode = (id: string, phone: string): ResponseType<ActivationCode> => {
  return axios.post(`/terminals/${id}/activationCode`, { phone });
};

export const getActivationCode = (id: string): ResponseType<ActivationCode> => {
  return axios.get(`/terminals/${id}/activationCode`);
};

export const deactivateTerminal = (id: string): ResponseType => {
  return axios.post(`/terminals/${id}/deactivate`);
};

export const closeTerminal = ({ id }: { id: string }): ResponseType => {
  return axios.post(`/terminals/${id}/close`);
};

export const issueApiKey = (terminalId: string) => {
  return axios.post<ApiKey>(`/terminals/${terminalId}/issueApiKey`).then((res) => res.data);
};

export const getApiKeyInfo = (terminalId: string) => {
  return axios
    .get<ApiKey>(`/terminals/${terminalId}/apiKey`, {
      validateStatus: (status) => status === 200 || status === 404,
    })
    .then((res) => res.data);
};

export const revokeApiKey = (terminalId: string) => {
  return axios.post(`/terminals/${terminalId}/revokeApiKey`);
};

export const getTerminalsById = (id: string) => {
  return axios.get<Terminal>(`/${terminals}/${id}`).then((res) => res.data);
};
